import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';
import { useContainerSpacing } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Home is expected to have a minimum padding of 24px.
 */
export const useHomeContainerSpacing = () => {
  const containerSpacing = useContainerSpacing();

  return useStyle(
    () => ({ paddingHorizontal: Math.max(containerSpacing, theme.spacing['6']) }),
    [containerSpacing],
  );
};
